(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-film"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-film-hero]').forEach(hero => {
    if (hero.dataset.ready) return;
    hero.dataset.ready = 'true';
    const video = hero.querySelector('video');
    const toggle = hero.querySelector('.film-hero-toggle');
    if (!video || !toggle) return;
    if (window.matchMedia('(max-width: 749px)').matches && video.dataset.mobileSrc) {
      video.querySelector('source').src = video.dataset.mobileSrc;
      video.load();
    }
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    const sync = () => {
      toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
    };
    const play = () => {
      video.muted = true;
      video.play().catch(() => { hero.classList.remove('has-played'); sync(); });
    };
    toggle.hidden = false;
    video.addEventListener('playing', () => { hero.classList.add('has-played'); sync(); });
    video.addEventListener('pause', sync);
    video.addEventListener('error', () => { hero.classList.remove('has-played'); toggle.hidden = true; });
    toggle.addEventListener('click', () => {
      if (video.paused) { userPaused = false; play(); }
      else { userPaused = true; video.pause(); }
    });
    motion.addEventListener('change', () => { if (motion.matches) video.pause(); else if (!userPaused) play(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (!motion.matches && !userPaused) play(); });
    if (!motion.matches && !navigator.connection?.saveData) play();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
